import API from "../BaseURL";

const configJson = {
    headers: {
      "content-type": "application/json",
    },
  };


export async function getAllRF_modules() {
    const res = API.get(`/rf_modules/`, configJson);
    return res;
}


export async function getRF_moduleInfo(rf_module_id) {
    const res = API.get(`/rf_modules/${rf_module_id}`, configJson);
    return res;
}


export async function createRF_module(data) {
    const res = API.post(`/rf_modules/`, data, configJson);
    return res;
}


export async function updateRF_module(rf_module_id, data) {
    const res = API.put(`/rf_modules/${rf_module_id}/`, data, configJson);
    return res;
}


export async function deleteRF_module(rf_module_id) {
    const res = API.delete(`/rf_modules/${rf_module_id}/`, configJson);
    return res;
}


export async function getRF_moduleByExploitation(exploitation_id) {
    const res = API.get(`/rf_modules/exploitation/${exploitation_id}`, configJson);
    return (await res).data;
}

